import { fetchDealerInfo } from '../services/service.dealer';
import EventBus from '../services/service.eventBus';
import { getAllOptimizelyVariables } from '../services/service.optimizely';
import { state as dynamicEntryState } from '../store/store.dynamic-entry';
import { state as landingState } from '../store/store.landing';

import { actions as pageParamsActions } from './actions.page-params';

const onReceivedParams = ({ offerCode, dealerId, installationMode, category }) => {
  try {
    onReceivedParamsSuccess({ offerCode, dealerId, installationMode, category });
  } catch (error) {
    onReceivedParamsFail(error);
  }
};
const onReceivedParamsSuccess = ({ offerCode, dealerId, installationMode, category }) => {
  EventBus.publish('ReceivedParams', { offerCode, dealerId, installationMode, category });
  landingState.offerCode = offerCode;
  landingState.dealerId = dealerId;
  landingState.installationMode = installationMode;
  pageParamsActions.onReceivedTrackingCategory(category);
  EventBus.publish('ReceivedParamsSuccess', {});
};

const onReceivedParamsFail = (error) => {
  EventBus.publish('ReceivedParamsFail', error);
};

const onStoreUpdate = (props = {}) => {
  Object.entries(props).forEach(([name, value]) => {
    landingState[name] = value;
  });
};

const ASSIGNED_MAIN_TITLE_FEATURE = 'assignedmaintitlecomponent';
const ASSIGNED_MAIN_IMAGE_FEATURE = 'assignedmainimagecomponent';
const CONTACT_US_COMPONENT = 'contactuscomponent';
const STEP_BY_STEP_COMPONENT = 'stepbystepcomponent';
const LANDING_FAQ_COMPONENT = 'faqscomponent';
const LANDING_LEGAL_COMPONENT = 'legalcomponent';

const FEATURES = {
  [ASSIGNED_MAIN_TITLE_FEATURE]: { subCopy: '', header: '' },
  [ASSIGNED_MAIN_IMAGE_FEATURE]: { base64TitleImage: '' },
  [CONTACT_US_COMPONENT]: {},
  [STEP_BY_STEP_COMPONENT]: { LandingAssigned: {} },
  [LANDING_FAQ_COMPONENT]: { faqTitle: '', faqData: '' },
  [LANDING_LEGAL_COMPONENT]: {},
};

const onOptimizelyFetching = async () => {
  try {
    await onOptimizelyFetchingSuccess();
  } catch (error) {
    onOptimizelyFetchingFail(error);
  }
};

const onOptimizelyFetchingSuccess = async () => {
  EventBus.publish('OptimizelyFetching', {});
  const optimizelyVariables = await getAllOptimizelyVariables(Object.keys(FEATURES), landingState.dealerId);
  Object.keys(FEATURES).forEach((featureName) => {
    const feature = optimizelyVariables.find((x) => x.featureName == featureName);
    if (feature && feature.variables) {
      Object.assign(FEATURES[featureName], JSON.parse(feature.variables));
    }
  });

  onStoreUpdate({
    assignedMainTitleSubCopy: FEATURES[ASSIGNED_MAIN_TITLE_FEATURE].subCopy,
    assignedMainTitleHeader: FEATURES[ASSIGNED_MAIN_TITLE_FEATURE].header,
    assignedMainImageTitleImage: FEATURES[ASSIGNED_MAIN_IMAGE_FEATURE].base64TitleImage,
    assignedStepByStep: FEATURES[STEP_BY_STEP_COMPONENT].LandingAssigned,
    faqTitle: FEATURES[LANDING_FAQ_COMPONENT].faqTitle,
    faqData: FEATURES[LANDING_FAQ_COMPONENT].faqData,
    contactUsComponent: FEATURES[CONTACT_US_COMPONENT],
    legalContents: FEATURES[LANDING_LEGAL_COMPONENT],
  });

  EventBus.publish('OptimizelyFetchingSuccess', { FEATURES });
};

const onOptimizelyFetchingFail = (error) => {
  EventBus.publish('OptimizelyFetchingFail', error);
};

const onFetchDealerInfo = async (dealerId) => {
  try {
    await onFetchDealerInfoSuccess(dealerId);
  } catch (error) {
    onFetchDealerInfoFail(error);
  }
};

const onFetchDealerInfoSuccess = async (dealerId) => {
  EventBus.publish('FetchDealerInfo', dealerId);
  const dealerResponse = await fetchDealerInfo(dealerId);
  const { displayName, phone } = extractDealerInfo(dealerResponse);
  onSetShiftDigitalContainer(dealerResponse);

  onStoreUpdate({
    assignedMainImageDealershipName: displayName,
    assignedMainImageDealershipPhone: phone,
    isAssignedOffer: true,
  });
  EventBus.publish('FetchDealerInfoSuccess', { dealerId, displayName, phone });
};

const onFetchDealerInfoFail = (error) => {
  EventBus.publish('FetchDealerInfoFail', error);
};

const isShiftDigitalDealer = (text, arr) => {
  return text && arr.some((element) => text.toString().toLowerCase().includes(element));
};

const onSetShiftDigitalContainer = (res) => {
  const { data } = res;
  if (!data) {
    return;
  }

  const { dealerGroups, displayName } = data;
  if (isShiftDigitalDealer(dealerGroups, ['fca'])) {
    dynamicEntryState.sdContainer = 'STELLANTIS';
  }
  if (isShiftDigitalDealer(displayName, ['toyota'])) {
    dynamicEntryState.sdContainer = 'TOYOTA';
  }
  if (isShiftDigitalDealer(displayName, ['lexus'])) {
    dynamicEntryState.sdContainer = 'LEXUS';
  }
  if (isShiftDigitalDealer(displayName, ['chevrolet', 'buick', 'gmc', 'cadillac'])) {
    dynamicEntryState.sdContainer = 'GMUS';
  }
  if (isShiftDigitalDealer(displayName, ['genesis'])) {
    dynamicEntryState.sdContainer = 'GENESISUS';
  }
  dynamicEntryState.oemDealerCode = data.oemDealerCode;
};

const extractDealerInfo = (rawResponse) => {
  try {
    if (rawResponse['data']) {
      return {
        displayName: rawResponse['data']['displayName'].replace('**', ''),
        phone: rawResponse['data']['phone'],
      };
    }
  } catch (err) {
    console.error('Error extractDealerInfo', err);
    return null;
  }
};

export default {
  onReceivedParams,
  onOptimizelyFetching,
  onStoreUpdate,
  onFetchDealerInfo,
};
